import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { restorePassword, sendAuthRequest } from './authApi';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserEmail, setUser, setUserEmail } from './authSlice';
import logo from '../../static/img/logo.jpg';

const Auth = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const email = useSelector(selectUserEmail)

    const [mode, setMode] = useState(null); // 'login' | 'register' | null
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [forgotPasswordMode, setForgotPasswordMode] = useState(false);

    const [name, setName] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');


    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');


        // Проверка на имя и совпадение паролей при регистрации
        if (mode === 'register') {
            if (!name.trim()) {
                setMessage('Пожалуйста, введите имя');
                return;
            }

            if (password !== confirmPassword) {
                setMessage('Пароли не совпадают');
                return;
            }
        }

        try {
            const payload = {
                email,
                password,
                mode,
                ...(mode === 'register' && { name }) // добавляем имя только при регистрации
            };

            const result = await sendAuthRequest(payload);
            console.log('result', result)
            if (result.user) {
                dispatch(setUser(result.user)); // сохраняем пользователя в Redux
                localStorage.setItem('authUser', JSON.stringify(result.user));
                navigate('/slots'); // переходим на слоты
            }

            setMessage(`Успешно: ${result.message}`);
        } catch (err) {
            setMessage(`Ошибка: ${err.message}`);
        }
    };


    const handlePasswordReset = async (e) => {
        e.preventDefault();
        setMessage('');
        try {
            await restorePassword( email );
            setMessage('Ссылка для восстановления отправлена на вашу почту.');
        } catch (err) {
            setMessage(`Ошибка при восстановлении: ${err.message}`);
        }
    };

    useEffect(() => {
        const storedUser = localStorage.getItem('authUser');
        if (storedUser) {
            const user = JSON.parse(storedUser);
            dispatch(setUser(user));
            dispatch(setUserEmail(user.email))
            navigate('/slots');
        }
    }, []);

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                backgroundColor: '#f5f5f5',
            }}
        >
            <div
                style={{
                    backgroundColor: 'white',
                    padding: '2rem',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                    textAlign: 'center',
                    width: '100%',
                    maxWidth: '400px',
                }}
            >
                <h2 style={{ marginBottom: '1rem' }}>Исцеление Единое Сердце</h2>

                <img src={logo} alt="Логотип" style={{ width: '280px', marginBottom: '2rem' }} />

                {mode === null && !forgotPasswordMode && (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginBottom: '2rem' }}>
                            <button
                                onClick={() => setMode('login')}
                                style={{
                                    padding: '0.5rem 1rem',
                                    border: '1px solid #007bff',
                                    color: '#007bff',
                                    borderRadius: '4px',
                                    background: 'transparent',
                                    cursor: 'pointer',
                                }}
                            >
                                Вход
                            </button>
                            <button
                                onClick={() => setMode('register')}
                                style={{
                                    padding: '0.5rem 1rem',
                                    border: '1px solid #007bff',
                                    color: '#007bff',
                                    borderRadius: '4px',
                                    background: 'transparent',
                                    cursor: 'pointer',
                                }}
                            >
                                Регистрация
                            </button>
                        </div>

                        <div style={{ marginTop: '2rem', fontSize: '16px' }}>
                            {/* <a
                                href=""
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#ff8562' }}
                            >
                                Видеоинструкция
                            </a> */}
                        </div>
                    </>
                )}

                {mode && !forgotPasswordMode && (
                    <form onSubmit={handleSubmit}>
                        {mode === 'register' && (
                            <input
                                type="text"
                                placeholder="Имя"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                                style={{
                                    width: '100%',
                                    padding: '0.5rem',
                                    marginBottom: '1rem',
                                    boxSizing: 'border-box',
                                }}
                            />
                        )}
                        <input
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => dispatch(setUserEmail(e.target.value))}
                            required
                            style={{
                                width: '100%',
                                padding: '0.5rem',
                                marginBottom: '1rem',
                                boxSizing: 'border-box',
                            }}
                        />
                        <input
                            type="password"
                            placeholder="Пароль"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            style={{
                                width: '100%',
                                padding: '0.5rem',
                                marginBottom: '1rem',
                                boxSizing: 'border-box',
                            }}
                        />
                        {mode === 'register' && (
                            <input
                                type="password"
                                placeholder="Подтвердите пароль"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                                style={{
                                    width: '100%',
                                    padding: '0.5rem',
                                    marginBottom: '1rem',
                                    boxSizing: 'border-box',
                                }}
                            />
                        )}
                        <button
                            type="submit"
                            style={{
                                width: '100%',
                                padding: '0.5rem',
                                backgroundColor: '#000',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                            }}
                        >
                            {mode === 'login' ? 'Войти' : 'Зарегистрироваться'}
                        </button>

                        <div style={{ marginTop: '1rem' }}>
                            <button
                                type="button"
                                onClick={() => setMode(null)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#007bff',
                                    cursor: 'pointer',
                                    textDecoration: 'underline',
                                }}
                            >
                                Назад
                            </button>
                        </div>

                        {mode === 'login' && (
                            <div style={{ marginTop: '1rem' }}>
                                <button
                                    type="button"
                                    onClick={() => setForgotPasswordMode(true)}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        color: '#ff8562',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        textDecoration: 'underline',
                                    }}
                                >
                                    Забыли пароль?
                                </button>
                            </div>
                        )}

                        {message && (
                            <p style={{ marginTop: '1rem', color: 'red' }}>{message}</p>
                        )}
                    </form>
                )}

                {forgotPasswordMode && (
                    <form onSubmit={handlePasswordReset}>
                        <p style={{ marginBottom: '1rem' }}>
                            Забыли пароль? Нет проблем. Просто сообщите ваш адрес электронной почты, и мы пришлём вам ссылку для сброса пароля.
                        </p>
                        <input
                            type="email"
                            placeholder="Адрес электронной почты"
                            value={email}
                            onChange={(e) => dispatch(setUserEmail(e.target.value))}
                            required
                            style={{
                                width: '100%',
                                padding: '0.5rem',
                                marginBottom: '1rem',
                                boxSizing: 'border-box',
                            }}
                        />
                        <button
                            type="submit"
                            style={{
                                width: '100%',
                                padding: '0.5rem',
                                backgroundColor: '#007bff',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                            }}
                        >
                            Восстановить
                        </button>

                        <div style={{ marginTop: '1rem' }}>
                            <button
                                type="button"
                                onClick={() => {
                                    setForgotPasswordMode(false);
                                    setMode(null);
                                }}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#007bff',
                                    cursor: 'pointer',
                                    textDecoration: 'underline',
                                }}
                            >
                                Назад
                            </button>
                        </div>

                        {message && (
                            <p style={{ marginTop: '1rem', color: 'green' }}>{message}</p>
                        )}
                    </form>
                )}
            </div>
        </div>
    );
};

export default Auth;
